import { createSelector } from 'reselect';

export const getMerchants = state =>
  state.merchants.merchantRegistrations.merchantRegistrationsCsv
    .failedMerchants;
export const getCurrentPage = state =>
  state.merchants.merchantRegistrations.merchantRegistrationsCsv.currentPage;

const perPage = 10;
const paginate = (list, page) =>
  list.slice((page - 1) * perPage, page * perPage);

export const getPaginatedMerchants = createSelector(
  getMerchants,
  getCurrentPage,
  paginate
);
